import React, { useState, useEffect } from "react";
import { EasyBefore } from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/Css/Profile.css";
import ProfileTab from "./ProfileTab";
import { useForm } from "./../../hooks/Form";
import { clearMessage, setSuccess } from "../../store/reducers/globalReducers";
import { useSelector, useDispatch } from "react-redux";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { useUserChangePasswordMutation } from "../../store/services/AuthServices";

const EditPassword = () => {
	const { state, onChange } = useForm({
		current_password: "",
		password: "",
		confirm_password: "",
	});
	const dispatch = useDispatch();
	const [errors, setErrors] = useState([]);
	const [ProfilePassEdit, response] = useUserChangePasswordMutation();
	let { success } = useSelector((state) => state.globalReducer);
	let navigate = useNavigate();

	const SaveChangePass = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("current_password", state.current_password);
		FormDatas.append("password", state.password);
		FormDatas.append("confirm_password", state.confirm_password);
		ProfilePassEdit(FormDatas);
	};

	useEffect(() => {
		if (success !== "") {
			ToastMessage(success);
			state.current_password = "";
			state.password = "";
			state.confirm_password = "";
			navigate("/account");
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (response?.error?.data?.errors === "Incorrect Old Password") {
			ToastMessage(response?.error?.data?.errors);
		} else {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			dispatch(setSuccess(response?.data?.message));
		}
	}, [response.isSuccess]);

	return (
		<div className="services Account">
			{/* Header */}
			<Header />
			{/* Header */}

			{/* Easy Plan Sec Start Here */}
			<section className="easy-plan mt-5">
				<div className="right-before">
					<figure>
						<img src={EasyBefore} alt="" className="img-fluid" />
					</figure>
				</div>
				<div className="container mt-5">
					<div className="row mb-3">
						<div className="col-lg-12 text-left">
							<p>
								Home{" "}
								<span className="fa fa-chevron-right chevron_right"> </span>{" "}
								Profile
							</p>
						</div>
					</div>
				</div>
			</section>

			{/* accout section starts*/}
			<section className="profile_section">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<ProfileTab />
						</div>
						<div className="col-lg-9">
							<div className="InfoDetails">
								<h3 className="heading_Account">Create New Password</h3>
								<div className="row">
									<div className="col-lg-6 my-2">
										<input
											type="password"
											className={`${
												errors && errors?.current_password
													? "SetErrorshow inpt_field"
													: "inpt_field"
											}`}
											placeholder="current_password"
											name="current_password"
											value={state?.current_password}
											onChange={onChange}
										/>
										{errors && errors?.current_password && (
											<span className="errorMessage">
												<p>{errors && errors?.current_password}</p>
											</span>
										)}
									</div>

									<div className="col-lg-6 my-2">
										<input
											type="password"
											className={`${
												errors && errors?.password
													? "SetErrorshow inpt_field"
													: "inpt_field"
											}`}
											placeholder="
                                            Password"
											name="password"
											value={state?.password}
											onChange={onChange}
										/>
										{errors && errors?.password && (
											<span className="errorMessage">
												<p>{errors && errors?.password}</p>
											</span>
										)}
									</div>

									<div className="col-lg-6 my-2">
										<input
											type="password"
											className={`${
												errors && errors?.confirm_password
													? "SetErrorshow inpt_field"
													: "inpt_field"
											}`}
											placeholder="
                                            Confirm_password"
											name="confirm_password"
											value={state?.confirm_password}
											onChange={onChange}
										/>
										{errors && errors?.confirm_password && (
											<span className="errorMessage">
												<p>{errors && errors?.confirm_password}</p>
											</span>
										)}
									</div>

									<div className="col-lg-6 my-2">
										{/* <input type='text' placeholder="Contact Number" className="inpt_field" /> */}
									</div>
									<div className="col-lg-6 mt-3">
										<button
											onClick={SaveChangePass}
											className="flit-btn bt-prof-green"
										>
											Save Changes
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* accout section ends*/}

			{/* Footer */}
			<Footer />
			{/* Footer */}
		</div>
	);
};

export default EditPassword;
